export default "__VITE_ASSET__DuL4DA7___"